import { isUuid } from "helpers/types/uuid"
import { useIsMultiDashboardsEnabled } from "resources/account"

/**
 * True only when the multi-dashboards flag is on AND this id is a real (UUID) instance — never
 * just the flag alone. A legacy/unmigrated dashboard (the "default" sentinel, a slug, or the
 * lazy-migration fallback rendered after `useLazyMigration` reports `migrationFailed`) has no
 * server-side workspace even when the account's flag is on, so it must be treated exactly like
 * flag-off by every persistence gate — there's no instance for `useWorkspaceSync` to write to.
 *
 * Single source of truth for that check: previously each of the 6 legacy per-subtype preference
 * hooks computed `skipSave` from the flag alone (forgetting the id check `useWorkspaceSync` and
 * `useInstanceWorkspaceLoader` already got right), which meant a failed migration silently
 * dropped every legacy write with no writer left to replace it.
 */
export function useIsRealInstance(dashboardId: string | null): boolean {
  return useIsMultiDashboardsEnabled() && isUuid(dashboardId)
}
